import { firebase } from '@lib/firebase';
import { useTranslation } from '@providers/I18n';

export const useUnavailabilityInterval = () => {
  const { t } = useTranslation();
  const isHidden: boolean = firebase.getRemoteConfigBoolean(
    'HIDE_TILL_TURN_BACK_OPTION',
  );

  return [
    {
      label: t('orderView.rejectOrder.unavailabilityInterval.HOUR', 'One Hour'),
      value: 'HOUR',
    },
    {
      label: t(
        'orderView.rejectOrder.unavailabilityInterval.TWO_HOURS',
        'Two Hour',
      ),
      value: 'TWO_HOURS',
    },
    {
      label: t(
        'orderView.rejectOrder.unavailabilityInterval.FOUR_HOURS',
        'Four Hours',
      ),
      value: 'FOUR_HOURS',
    },
    {
      label: t(
        'orderView.rejectOrder.unavailabilityInterval.NEXT_DAY',
        'Till the next day',
      ),
      value: 'NEXT_DAY',
    },

    {
      label: t(
        'orderView.rejectOrder.unavailabilityInterval.TWO_DAYS',
        '48 Hours',
      ),
      value: 'TWO_DAYS',
    },
    {
      label: t(
        'orderView.rejectOrder.unavailabilityInterval.THREE_DAYS',
        '72 Hours',
      ),
      value: 'THREE_DAYS',
    },
    {
      label: t(
        'orderView.rejectOrder.unavailabilityInterval.FOREVER',
        'Till I turn it back on',
      ),
      value: 'FOREVER',
      hide: isHidden,
    },
  ];
};
